import React from 'react';
import useFilterStore from 'zustandStore/useFilterStore';
import RpSelect from 'components/commons/RpSelect';
import PropTypes from 'prop-types';

const SelectFilter = React.memo(function SelectFilter(props) {
    const setFilters = useFilterStore(state => state.setFilters);
    const isDefault = useFilterStore(state => state.isDefaultFilterValue);
    const filters = useFilterStore(state => state.filters[props.comparableType]?.[props.attrName]);

    const handleChange = (inputValue) => {
        setFilters(props.comparableType, { [props.attrName]: inputValue.value });
    };

    const getFormattedValue = () => {
        if (!filters) return null;
        const matchedOption = props.options.find(opt => opt.value === filters);
        return matchedOption || { label: filters, value: filters };
    };

    return (
        <RpSelect
            title={props.title}
            subTitle={props.subTitle}
            onChange={handleChange}
            options={props.options}
            value={getFormattedValue()}
            isDefault={isDefault(props.comparableType, props.attrName, filters)}
            shouldUpdateInputText={props.shouldUpdateInputText}
            maxInputLength={60}
        />
    );
});

SelectFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
    attrName: PropTypes.string.isRequired,
    title: PropTypes.string,
    subTitle: PropTypes.string,
    options: PropTypes.array.isRequired,
    shouldUpdateInputText: PropTypes.func,
};

export default SelectFilter;
